import PropTypes from 'prop-types';

import useIsMobile from '@/src/hooks/useIsMobile';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Text} from '../../../ui';
import css from '../../styles/TopicTitle.module.css';

const TopicTitle = ({title, duration, videoCount, onClick}) => {
  const {isMaxWidth600} = useIsMobile();
  return (
    <div className={css.main}>
      <div className={css.title} onClick={onClick}>
        <Text
          isOneLine
          fontSize={
            isMaxWidth600 ? Text.FONT_SIZE.SIZE_12 : Text.FONT_SIZE.SIZE_16
          }
          fontWeight={Text.FONT_WEIGHT.BOLD}
        >
          {title}
        </Text>
      </div>
      {Boolean(videoCount) && (
        <div>
          <Text
            color={Text.COLOR.GREY}
            fontSize={
              isMaxWidth600 ? Text.FONT_SIZE.SIZE_12 : Text.FONT_SIZE.SIZE_14
            }
            fontWeight={Text.FONT_WEIGHT.MEDIUM}
          >
            <div className={css.online}>
              {videoCount}{' '}
              <TextLocal
                id={
                  videoCount <= 1
                    ? 'courseDetails.video'
                    : 'courseDetails.videos'
                }
              />{' '}
              | {duration}
            </div>
          </Text>
        </div>
      )}
    </div>
  );
};

export default TopicTitle;

TopicTitle.propTypes = {
  title: PropTypes.string.isRequired,
  duration: PropTypes.string.isRequired,
  videoCount: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};
